import { MapEmbed, directionsUrl } from '../components/MapEmbed';
import { useDocumentMeta } from '../lib/seo';

const HOURS = [
  { label: 'Sunday', value: 'Closed' },
  { label: 'Monday', value: '10:00 AM – 7:00 PM' },
  { label: 'Tuesday', value: '10:00 AM – 7:00 PM' },
  { label: 'Wednesday', value: '10:00 AM – 7:00 PM' },
  { label: 'Thursday', value: '10:00 AM – 7:00 PM' },
  { label: 'Friday', value: '9:00 AM – 7:00 PM' },
  { label: 'Saturday', value: '9:00 AM – 7:00 PM' },
];

export function Location() {
  useDocumentMeta(
    'Location & Hours | Nine80 Hair Studio',
    'Nine80 Hair Studio — 50 Concord Commons Pl SW, Concord, NC 28027. Hours and directions.',
  );

  return (
    <div className="mx-auto max-w-5xl px-4 py-16 grid gap-10 sm:grid-cols-2">
      <div className="space-y-6">
        <h1 className="text-4xl">Location &amp; Hours</h1>
        <div className="card space-y-2">
          <p className="text-lg">50 Concord Commons Pl SW</p>
          <p className="text-lg">Concord, NC 28027</p>
          <a href="tel:+19802558167" className="text-primary text-lg hover:underline block mt-2">
            (980) 255-8167
          </a>
          <a
            href={directionsUrl()}
            target="_blank"
            rel="noreferrer noopener"
            className="btn-secondary mt-3"
          >
            Get Directions
          </a>
        </div>
        <div className="card">
          <h2 className="text-xl mb-3">Hours</h2>
          <dl className="space-y-1">
            {HOURS.map((h) => (
              <div key={h.label} className="flex justify-between text-fg-muted">
                <dt>{h.label}</dt>
                <dd className="text-fg">{h.value}</dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
      <MapEmbed />
    </div>
  );
}
